<div class="emerald-modal-container" style="position: relative;">
    <div class="mdc-dialog__header custom-header" *ngIf="isModal">
        <h2 class="mdc-dialog__title">
            {{ isEditMode ? 'Edit Request' : 'Create New Request' }}
        </h2>
        <button mat-icon-button class="cancel-header-btn" (click)="onCancel()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="mdc-dialog__content emerald-modal-content">
        <div class="emerald-form-container" [formGroup]="requestForm">
            <app-title-field [title]="'General Information'"></app-title-field>            <div class="form-section">
                <mat-form-field class="required-field emerald-dropdown" appearance="outline" floatLabel="always">
                    <mat-label>Date of Pickup</mat-label>
                    <input matInput [matDatepicker]="pickerDateOfPickup" formControlName="dateOfPickup" placeholder="MM/DD/YYYY" required>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfPickup"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateOfPickup></mat-datepicker>
                </mat-form-field>
                <app-dropdown class="emerald-dropdown dropdown-cls" [required]="true" [options]="locationOptions"
                    [valueKey]="'value'" [outlined]="true" [displayKey]="'label'" [label]="'Location'"
                    [disabled]="isEditMode" formControlName="location"></app-dropdown>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 8px;">
                <mat-form-field class="autocomplete-field emerald-dropdown" appearance="outline" floatLabel="always"
                    style="flex: 1; margin-bottom: 0;">
                    <mat-label>Search Employee Email</mat-label>
                    <input #emailAutoInput type="text" matInput placeholder="Type to search email"
                        [matAutocomplete]="autoEmail" [formControl]="myControl" />
                    <mat-autocomplete #autoEmail="matAutocomplete" [displayWith]="displayEmailFn"
                        (optionSelected)="onEmployeeEmailOptionSelected($event)">
                        <mat-option *ngFor="let option of options" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <app-button-group [buttonType]="'Primary'" [buttonUseCase]="'add'" [label]="'Add to TO'"
                    [disabled]="isEditMode" (click)="onEmployeeEmailButtonClick()" style="margin-bottom: 12px;">
                </app-button-group>
                <app-button-group [buttonType]="'Secondary'" [buttonUseCase]="'add'" [label]="'Add to CC'"
                    [disabled]="isEditMode" (click)="onEmployeeEmailCcButtonClick()" style="margin-bottom: 12px;">
                </app-button-group>
            </div>
            <div *ngIf="duplicateEmailError" class="email-error-message" style="color: #d32f2f; margin-bottom: 8px;">
                {{ duplicateEmailError }}
            </div>
            <div class="email-container">
                <div class="email-sections-wrapper">
                    <div class="email-section email-section-left" *ngIf="toEmails.length > 0">
                        <h4>TO Email :</h4>
                        <div class="email-list email-list-horizontal">
                            <div class="email-item" *ngFor="let email of toEmails; let i = index">
                                <span class="email-text">{{ email }}</span>
                                <button class="email-remove-btn" [disabled]="isEditMode" (click)="removeToEmail(i)" type="button"
                                    aria-label="Remove email">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="email-section email-section-right" *ngIf="ccEmails.length > 0">
                        <h4>CC Email :</h4>
                        <div class="email-list email-list-horizontal">
                            <div class="email-item" *ngFor="let email of ccEmails; let i = index">
                                <span class="email-text">{{ email }}</span>
                                <button class="email-remove-btn" [disabled]="isEditMode" (click)="removeCcEmail(i)" type="button"
                                    aria-label="Remove email">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-emails" *ngIf="toEmails.length === 0 && ccEmails.length === 0">
                    <p>No email notifications loaded for the selected location.</p>
                </div>
            </div>
            <app-title-field [title]="'Resource Information'"></app-title-field>
            <div class="form-section">
                <app-input-field class="my-custom-input" [label]="'Resource Email'" [outlined]="true" [type]="'email'"
                    [required]="true" formControlName="email"></app-input-field>
                <mat-form-field class="required-field emerald-dropdown" appearance="outline" floatLabel="always">
                    <mat-label>Date of Joining</mat-label>
                    <input matInput [matDatepicker]="pickerDateOfJoining" formControlName="dateOfJoining" placeholder="MM/DD/YYYY" required>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerDateOfJoining"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateOfJoining></mat-datepicker>
                </mat-form-field>
                <app-input-field class="my-custom-input" [label]="'Resource First Name'" [outlined]="true"
                    [type]="'text'" [required]="true" formControlName="firstName"></app-input-field>
                <app-input-field class="my-custom-input" [label]="'Resource Last Name'" [outlined]="true"
                    [type]="'text'" [required]="true" formControlName="lastName"></app-input-field>
                <mat-form-field class="autocomplete-field emerald-dropdown" appearance="outline" floatLabel="always">
                    <mat-label>D&amp;T Leader Name</mat-label>
                    <input type="text" placeholder="Select a leader" aria-label="D&T Leader Name" matInput
                        formControlName="DnTLeader" [matAutocomplete]="autoLeader">
                    <mat-autocomplete #autoLeader="matAutocomplete" [displayWith]="displayLeaderFn">
                        <mat-option *ngFor="let option of filteredLeaderOptions$ | async" [value]="option">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="autocomplete-field emerald-dropdown" appearance="outline" floatLabel="always">
                    <mat-label>Reporting Manager Name</mat-label>
                    <input type="text" placeholder="Select a manager" aria-label="Reporting Manager Name" matInput
                        formControlName="reportingManager" [matAutocomplete]="autoManager">
                    <mat-autocomplete #autoManager="matAutocomplete" [displayWith]="displayManagerFn">
                        <mat-option *ngFor="let option of filteredManagerOptions$ | async" [value]="option">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <app-input-field class="my-custom-input" [label]="'PS ID'" [outlined]="true" [type]="'text'"
                    [required]="true" formControlName="employeeId"></app-input-field>
            </div>
            <app-title-field [title]="'Accessories Information'"></app-title-field>
            <div class="form-section">
                <app-dropdown class="emerald-dropdown" [options]="osTypeOptions" [label]="'OS Type'"
                    [outlined]="true" [displayKey]="'label'" [required]="true" [valueKey]="'value'"
                    formControlName="osType" [required]="true" (selectionChange)="onOsTypeChange($event)">
                </app-dropdown>
                <app-dropdown class="emerald-dropdown" [options]="brandNameOptions"
                    [label]="'Laptop Brand'" [outlined]="true" [displayKey]="'label'" [required]="true"
                    [valueKey]="'value'" formControlName="brandName" [required]="true"
                    (selectionChange)="onBrandNameChange($event)">
                </app-dropdown>
                <app-dropdown class="emerald-dropdown" [options]="laptopTypeOptions"
                    [label]="'Laptop Type'" [outlined]="true" [displayKey]="'label'" [required]="true"
                    [valueKey]="'value'" formControlName="laptopType" [required]="true">
                </app-dropdown>
                <app-input-field class="my-custom-input" [label]="'Laptop Serial Number'" [outlined]="true"
                    [type]="'text'"   [required]="requestForm.get('status')?.value?.toLowerCase() === 'cancelled'"  formControlName="laptopSerialNumber"></app-input-field>
                <app-input-field class="my-custom-input" [label]="'Charger Serial Number'" [outlined]="true"
                    [type]="'text'"  [required]="requestForm.get('status')?.value?.toLowerCase() === 'cancelled'"  formControlName="chargerSerialNumber"></app-input-field>
                <!-- Status Dropdown -->
                <div class="status-label-container">
                    <app-status-label
                    [showDropdown]="true"
                    [category]="'Request'"
                    [statusV]="requestForm.get('status')?.value || 'Initiated'"
                    (statusChange)="requestForm.get('status')?.setValue($event)"
                    ></app-status-label>
                </div>
                <ng-container>
                    <app-dropdown class="emerald-dropdown dropdown-cls" [options]="accessoryOptions"
                        [id]="'multi_select'" [label]="'Accessories Type'" [outlined]="true" [multiSelect]="true"
                        [valueKey]="'value'" [displayKey]="'label'" formControlName="accessoriesType" [required]="true">
                    </app-dropdown>
                </ng-container>

            </div>
            
            <div class="form-section single-column">
                <app-input-field class="my-custom-input" [label]="'Comments'" [outlined]="true" [type]="'text'"
                    [required]="requestForm.get('status')?.value?.toLowerCase() === 'cancelled'" 
                    [placeholder]="'Add any comments or notes about this request...'"
                    formControlName="comments"></app-input-field>
            </div>
            <div>
                <app-file-upload [label]="'Raise Asset Request File'"
                    formControlName="raiseAssetRequestFileName"
                    [fileName]="selectedFile ? selectedFile : ''"></app-file-upload>
                <div *ngIf="requestForm.get('raiseAssetRequestFileName')?.invalid" class="validation-error-message"
                    style="color: #d32f2f; font-size: 12px; margin-top: 4px; margin-left: 4px;">
                    <span *ngIf="requestForm.get('raiseAssetRequestFileName')?.errors?.['required']">
                        File upload is required for Mac OS type.
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="mdc-dialog__actions emerald-modal-actions">
        <app-button-group [buttonUseCase]="'Cancel'" [buttonType]="'Secondary'" [label]="'Cancel'"
            [iconFillType]="'outlined'" [cssClass]="'cancel-btn'" (click)="onCancel()"></app-button-group>
        <app-button-group [buttonType]="'Primary'" [buttonUseCase]="'add'" [label]="'Save'"
            (click)="isEditMode ? onEditSubmit() : onSubmit()"></app-button-group>
    </div>
</div>